export default __webpack_public_path__ + "static/media/bg02.182c8bcf.jpg";